module.exports = __webpack_public_path__ + "assets/img/btn-detail-8c28f9ef.png";